/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EditExpenseCommand } from '../../models/edit-expense-command';
import { ExpenseDtoApiResponse } from '../../models/expense-dto-api-response';

export interface EditExpenseAsync$Params {
  id: number;
      body?: EditExpenseCommand
}

export function editExpenseAsync(http: HttpClient, rootUrl: string, params: EditExpenseAsync$Params, context?: HttpContext): Observable<StrictHttpResponse<ExpenseDtoApiResponse>> {
  const rb = new RequestBuilder(rootUrl, editExpenseAsync.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ExpenseDtoApiResponse>;
    })
  );
}

editExpenseAsync.PATH = '/api/expense/{id}';
